export const AUTH_ERRORS = {
  ACCOUNT_BLOCKED: "ACCOUNT_BLOCKED",
  TWOFA_REQUIRED: "TWOFA_REQUIRED",
  TWOFA_INVALID: "TWOFA_INVALID",
};
